export default __webpack_public_path__ + "img/catIcon332.6c9368c8.svg";